import React, { useState, useRef, useEffect, useCallback } from 'react';
import { auth, db } from '../FirebaseComp/firebase';
import { collection, getDocs, deleteDoc, doc, updateDoc, addDoc, query, orderBy, onSnapshot, limit, where, serverTimestamp, setDoc } from 'firebase/firestore';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import './adminpanel.css';
import { FiUser, FiTruck, FiMapPin, FiCamera, FiUpload, FiSave } from 'react-icons/fi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash, faSpinner, faSearch, faFilter } from '@fortawesome/free-solid-svg-icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { createUserWithEmailAndPassword } from "firebase/auth";



import { faUser } from '@fortawesome/free-solid-svg-icons';





const storage = getStorage();

function AdminPanel() {
  const [activeTab, setActiveTab] = useState('createDrivers');
  const [users, setUsers] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [error, setError] = useState(null);
  const fileInputRef = useRef();
  const [driverData, setDriverData] = useState({
    driverId: "",
    name: "",
    email: "",
    password: "",
    phone: "",
    whatsapp: "",
    nic: "",
    address: "",
    vehicleType: "",
    vehicleName: "",
    numberPlate: "",
    ratePerKm: "",
    province: "",
    district: "",
    city: "",
    imageUrl: "",
  });
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [modalType, setModalType] = useState(null);




// State for tour management
const [selectedDriverId, setSelectedDriverId] = useState('');
const [selectedDriverDetails, setSelectedDriverDetails] = useState(null);
const [tours, setTours] = useState([]);
const [loadingTours, setLoadingTours] = useState(true);
const [searchTerm, setSearchTerm] = useState('');
const [filterDriver, setFilterDriver] = useState('');


const [tourData, setTourData] = useState({
  pickupLocation: '',
  dropLocation: '',
  tourDate: '',
  tourTime: '',
  tourCharges: '',
  notes: ''
});

// Fetch driver details when selected
useEffect(() => {
  if (selectedDriverId) {
    const driver = drivers.find(d => d.id === selectedDriverId);
    setSelectedDriverDetails(driver);
  } else {
    setSelectedDriverDetails(null);
  }
}, [selectedDriverId, drivers]);


// Fetch tours when the tab is active
useEffect(() => {
  if (activeTab === 'tourHistory') {
    fetchTours();
  }
}, [activeTab]);





























  // Fetch drivers from Firebase
  const fetchDrivers = async () => {
    try {
      setLoading(true);
      const querySnapshot = await getDocs(collection(db, 'drivers'));
      const driversData = [];
      
      querySnapshot.forEach((doc) => {
        driversData.push({ id: doc.id, ...doc.data() });
      });
      
      setDrivers(driversData);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch drivers');
      setLoading(false);
      console.error('Error fetching drivers:', err);
    }
  };

  useEffect(() => {
    fetchDrivers();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDriverData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 2 * 1024 * 1024) {
      alert("File size exceeds 2MB limit");
      return;
    }

    setUploading(true);
    try {
      const storageRef = ref(storage, `drivers/${Date.now()}-${file.name}`);
      await uploadBytes(storageRef, file);
      const url = await getDownloadURL(storageRef);

      setDriverData((prev) => ({
        ...prev,
        imageUrl: url,
      }));
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("Failed to upload image");
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!driverData.imageUrl) {
      alert("Please upload a driver photo");
      return;
    }

    try {
      setUploading(true);
      
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        driverData.email,
        driverData.password
      );
      const uid = userCredential.user.uid;

      await setDoc(doc(db, "drivers", uid), {
        driverId: driverData.driverId,
        name: driverData.name,
        email: driverData.email,
        phone: driverData.phone,
        whatsapp: driverData.whatsapp,
        nic: driverData.nic,
        address: driverData.address,
        vehicleType: driverData.vehicleType,
        vehicleName: driverData.vehicleName,
        numberPlate: driverData.numberPlate,
        ratePerKm: driverData.ratePerKm,
        province: driverData.province,
        district: driverData.district,
        city: driverData.city,
        imageUrl: driverData.imageUrl,
        createdAt: serverTimestamp(),
      });

      alert("Driver account created ✅");
      
      setDriverData({
        driverId: "",
        name: "",
        email: "",
        password: "",
        phone: "",
        whatsapp: "",
        nic: "",
        address: "",
        vehicleType: "",
        vehicleName: "",
        numberPlate: "",
        ratePerKm: "",
        province: "",
        district: "",
        city: "",
        imageUrl: "",
      });

      if (fileInputRef.current) fileInputRef.current.value = "";

    } catch (error) {
      console.error("Error creating driver: ", error);
      alert("Failed to create driver ❌: " + error.message);
    } finally {
      setUploading(false);
    }
  };

  const fetchUsers = useCallback(async () => {
    try {
      const userRef = collection(db, 'users');
      const snapshot = await getDocs(userRef);
      const usersData = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      setUsers(usersData);
    } catch (error) {
      console.error("Error fetching users:", error.message);
    }
  }, []);

  useEffect(() => {
    if (activeTab === 'viewUsers' || activeTab === 'manageUsers') {
      fetchUsers();
    }
  }, [activeTab, fetchUsers]);

  const handleRemoveUser = async (userId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this member?");
    if (!confirmDelete) return; 

    try {
      await deleteDoc(doc(db, 'users', userId));  
      setUsers(prevUsers => prevUsers.filter(user => user.id !== userId)); 
    } catch (error) {
      console.error("Error removing user:", error.message);
    }
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const handleLogout = async () => {
    try {
      await auth.signOut();
      window.location.href = '/';  
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  useEffect(() => {
    document.body.classList.add('admin-panel-active');
    return () => {
      document.body.classList.remove('admin-panel-active');
    };
  }, []);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "contactus"));
        const contactMessages = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMessages(contactMessages);
      } catch (error) {
        console.error("Error fetching messages:", error);
      }
    };

    fetchMessages();
  }, []);

  useEffect(() => {
    const fetchFeedbacks = async () => {
      try {
        const feedbacksCollection = collection(db, "feedbacks");
        const snapshot = await getDocs(feedbacksCollection);
        const feedbackList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setFeedbacks(feedbackList);
      } catch (error) {
        console.error("Error fetching feedbacks:", error);
      }
    };

    fetchFeedbacks();
  }, []);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "bookings"));
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setBookings(data);
      } catch (error) {
        console.error("Error fetching bookings:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBookings();
  }, []);

  const updateDriverStatus = async (driverId, newStatus) => {
    try {
      const driverRef = doc(db, 'drivers', driverId);
      await updateDoc(driverRef, { status: newStatus });
      
      setDrivers(drivers.map(driver => 
        driver.id === driverId ? { ...driver, status: newStatus } : driver
      ));
    } catch (err) {
      setError('Failed to update driver status');
      console.error('Error updating driver status:', err);
    }
  };

  const updateDriverDetails = async (driverId, updatedData) => {
    try {
      const driverRef = doc(db, 'drivers', driverId);
      await updateDoc(driverRef, updatedData);
      
      setDrivers(drivers.map(driver => 
        driver.id === driverId ? { ...driver, ...updatedData } : driver
      ));
    } catch (err) {
      setError('Failed to update driver details');
      console.error('Error updating driver details:', err);
    }
  };

  const deleteDriver = async (driverId) => {
    try {
      await deleteDoc(doc(db, 'drivers', driverId));
      
      setDrivers(drivers.filter(driver => driver.id !== driverId));
    } catch (err) {
      setError('Failed to delete driver');
      console.error('Error deleting driver:', err);
    }
  };

  const handleViewProfile = (driver) => {
    setSelectedDriver(driver);
    setModalType('profile');
  };

  const handleEdit = (driver) => {
    setSelectedDriver(driver);
    setModalType('edit');
  };

  const handleDelete = (driver) => {
    setSelectedDriver(driver);
    setModalType('delete');
  };

  const handleToggleStatus = (driverId, currentStatus) => {
    const newStatus = currentStatus === 'active' ? 'inactive' : 'active';
    updateDriverStatus(driverId, newStatus);
  };

  const handleSaveEdit = (updatedDriver) => {
    updateDriverDetails(selectedDriver.id, updatedDriver);
    setModalType(null);
    setSelectedDriver(null);
  };

  const handleConfirmDelete = (driverId) => {
    deleteDriver(driverId);
    setModalType(null);
    setSelectedDriver(null);
  };

  const closeModal = () => {
    setModalType(null);
    setSelectedDriver(null);
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    
    if (timestamp.seconds) {
      return new Date(timestamp.seconds * 1000).toLocaleDateString();
    }
    
    return new Date(timestamp).toLocaleDateString();
  };

  if (loading) return <div className="loading">Loading drivers...</div>;
  if (error) return <div className="error">{error}</div>;










//tour history and manage




// Fetch all tours
const fetchTours = async () => {
  try {
    setLoadingTours(true);
    const querySnapshot = await getDocs(collection(db, 'tours'));
    const toursData = [];
    
    querySnapshot.forEach((doc) => {
      toursData.push({ id: doc.id, ...doc.data() });
    });
    
    // Sort by date (newest first)
    toursData.sort((a, b) => {
      const dateA = new Date(a.tourDate + 'T' + a.tourTime);
      const dateB = new Date(b.tourDate + 'T' + b.tourTime);
      return dateB - dateA;
    });
    
    setTours(toursData);
    setLoadingTours(false);
  } catch (err) {
    console.error('Error fetching tours:', err);
    setLoadingTours(false);
    toast.error('Failed to fetch tours');
  }
};

// Filter tours based on search term and driver filter
const filteredTours = tours.filter(tour => {
  const matchesSearch = 
    tour.driverName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    tour.pickupLocation.toLowerCase().includes(searchTerm.toLowerCase()) ||
    tour.dropLocation.toLowerCase().includes(searchTerm.toLowerCase()) ||
    tour.tourId.toLowerCase().includes(searchTerm.toLowerCase());
  
  const matchesDriver = filterDriver ? tour.driverId === filterDriver : true;
  
  return matchesSearch && matchesDriver;
});

// Handle tour submission
const handleTourSubmit = async (e) => {
  e.preventDefault();
  
  if (!selectedDriverDetails) {
    toast.error('Please select a driver');
    return;
  }
  
  try {
    // Generate a unique tour ID
    const tourId = 'TOUR-' + Date.now().toString().slice(-6);
    
    // Save tour to Firestore
    await addDoc(collection(db, 'tours'), {
      tourId,
      driverId: selectedDriverDetails.driverId,
      driverName: selectedDriverDetails.name,
      driverEmail: selectedDriverDetails.email,
      pickupLocation: tourData.pickupLocation,
      dropLocation: tourData.dropLocation,
      tourDate: tourData.tourDate,
      tourTime: tourData.tourTime,
      tourCharges: tourData.tourCharges,
      notes: tourData.notes,
      status: 'completed',
      createdAt: serverTimestamp()
    });
    
    toast.success('Tour created successfully!');
    
    // Reset form
    setSelectedDriverId('');
    setTourData({
      pickupLocation: '',
      dropLocation: '',
      tourDate: '',
      tourTime: '',
      tourCharges: '',
      notes: ''
    });
    
    // Refresh tours list
    fetchTours();
    
  } catch (err) {
    console.error('Error creating tour:', err);
    toast.error('Failed to create tour');
  }
};

// Handle tour actions
const handleViewTour = (tour) => {
  // Implement view tour details
  console.log('View tour:', tour);
  // You can create a modal to show tour details
};

const handleEditTour = (tour) => {
  // Implement edit tour
  console.log('Edit tour:', tour);
  // You can create a modal to edit tour details
};

const handleDeleteTour = async (tourId) => {
  if (!window.confirm('Are you sure you want to delete this tour?')) {
    return;
  }
  
  try {
    await deleteDoc(doc(db, 'tours', tourId));
    toast.success('Tour deleted successfully!');
    fetchTours(); // Refresh the list
  } catch (err) {
    console.error('Error deleting tour:', err);
    toast.error('Failed to delete tour');
  }
};

























  return (
    <div className="admin-panel">
      <div className="top-bar">
        <ul className="tabs">
          <li className={`tab ${activeTab === 'createDrivers' ? 'active' : ''}`} onClick={() => handleTabClick('createDrivers')}>
            Create Drivers
          </li>
          <li className={`tab ${activeTab === 'manageDrivers' ? 'active' : ''}`} onClick={() => handleTabClick('manageDrivers')}>
           Manage Drivers
          </li>
          <li className={`tab ${activeTab === 'viewAllBookings' ? 'active' : ''}`} onClick={() => handleTabClick('viewAllBookings')}>
            View All Bookings
          </li>
          <li className={`tab ${activeTab === 'toursHistory' ? 'active' : ''}`} onClick={() => handleTabClick('tourHistory')}>
            Tours History
          </li>
          <li className={`tab ${activeTab === 'viewAllFeedbacks' ? 'active' : ''}`} onClick={() => handleTabClick('viewAllFeedbacks')}>
             View All Feedbacks
          </li>
          <li className={`tab ${activeTab === 'contactMessage' ? 'active' : ''}`} onClick={() => handleTabClick('contactMessage')}>
            Contact Messages
          </li>
        </ul>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="main-content">
        {activeTab === "createDrivers" && (
          <div className="driver-form">
            <h1 className="driver-form__header">Create New Driver</h1>
            
            <form onSubmit={handleSubmit}>
              <section className="driver-form__section">
                <h2 className="driver-form__section-header">
                  <FiUser /> Personal Information
                </h2>
                <div className="driver-form__grid">
                  <div className="driver-form__group">
                    <label className="driver-form__label">Driver ID (Unique)</label>
                    <input
                      type="text"
                      name="driverId"
                      value={driverData.driverId}
                      onChange={handleChange}
                      className="driver-form__input"
                      required
                    />
                  </div>
                  
                  <div className="driver-form__group">
                    <label className="driver-form__label">Full Name</label>
                    <input
                      type="text"
                      name="name"
                      value={driverData.name}
                      onChange={handleChange}
                      className="driver-form__input"
                      required
                    />
                  </div>
                  
                  <div className="driver-form__group">
                    <label className="driver-form__label">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={driverData.email}
                      onChange={handleChange}
                      className="driver-form__input"
                      required
                    />
                  </div>
                  
                  <div className="driver-form__group">
                    <label className="driver-form__label">Password</label>
                    <input
                      type="password"
                      name="password"
                      value={driverData.password}
                      onChange={handleChange}
                      className="driver-form__input"
                      required
                    />
                  </div>
                  
                  <div className="driver-form__group">
                    <label className="driver-form__label">Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      value={driverData.phone}
                      onChange={handleChange}
                      className="driver-form__input"
                      required
                    />
                  </div>
                  
                  <div className="driver-form__group">
                    <label className="driver-form__label">WhatsApp Number</label>
                    <input
                      type="tel"
                      name="whatsapp"
                      value={driverData.whatsapp}
                      onChange={handleChange}
                      className="driver-form__input"
                    />
                  </div>
                  
                  <div className="driver-form__group">
                    <label className="driver-form__label">NIC Number</label>
                    <input
                      type="text"
                      name="nic"
                      value={driverData.nic}
                      onChange={handleChange}
                      className="driver-form__input"
                      required
                    />
                  </div>
                  
                  <div className="driver-form__group">
                    <label className="driver-form__label">Address</label>
                    <textarea
                      name="address"
                      value={driverData.address}
                      onChange={handleChange}
                      className="driver-form__input driver-form__textarea"
                      required
                    />
                  </div>
                </div>
              </section>

              <section className="driver-form__section">
                <h2 className="driver-form__section-header">
                  <FiTruck /> Vehicle Information
                </h2>
                <div className="driver-form__grid">
                  <div className="driver-form__group">
                    <label className="driver-form__label">Vehicle Type</label>
                    <select
                      name="vehicleType"
                      value={driverData.vehicleType}
                      onChange={handleChange}
                      className="driver-form__input driver-form__select"
                      required
                    >
                      <option value="">Select Type</option>
                      <option value="car">Car</option>
                      <option value="van">Van</option>
                      <option value="suv">SUV</option>
                      <option value="truck">Truck</option>
                    </select>
                  </div>
                  
                  <div className="driver-form__group">
                    <label className="driver-form__label">Vehicle Name/Model</label>
                    <input
                      type="text"
                      name="vehicleName"
                      value={driverData.vehicleName}
                      onChange={handleChange}
                      className="driver-form__input"
                      required
                    />
                  </div>
                  
                  <div className="driver-form__group">
                    <label className="driver-form__label">Number Plate</label>
                    <input
                      type="text"
                      name="numberPlate"
                      value={driverData.numberPlate}
                      onChange={handleChange}
                      className="driver-form__input"
                      required
                    />
                  </div>
                  
                  <div className="driver-form__group">
                    <label className="driver-form__label">Rate per Kilometer (LKR)</label>
                    <input
                      type="number"
                      name="ratePerKm"
                      value={driverData.ratePerKm}
                      onChange={handleChange}
                      className="driver-form__input"
                      required
                    />
                  </div>
                </div>
              </section>

              <section className="driver-form__section">
                <h2 className="driver-form__section-header">
                  <FiMapPin /> Location Information
                </h2>
                <div className="driver-form__grid">
                  <div className="driver-form__group">
                    <label className="driver-form__label">Province</label>
                    <select
                      name="province"
                      value={driverData.province}
                      onChange={handleChange}
                      className="driver-form__input driver-form__select"
                      required
                    >
                      <option value="">Select Province</option>
                      <option value="Western">Western</option>
                      <option value="Central">Central</option>
                      <option value="Southern">Southern</option>
                      <option value="Northern">Northern</option>
                      <option value="Eastern">Eastern</option>
                      <option value="North Western">North Western</option>
                      <option value="North Central">North Central</option>
                      <option value="Uva">Uva</option>
                      <option value="Sabaragamuwa">Sabaragamuwa</option>
                    </select>
                  </div>
                  
                  <div className="driver-form__group">
                    <label className="driver-form__label">District</label>
                    <input
                      type="text"
                      name="district"
                      value={driverData.district}
                      onChange={handleChange}
                      className="driver-form__input"
                      required
                    />
                  </div>
                  
                  <div className="driver-form__group">
                    <label className="driver-form__label">City</label>
                    <input
                      type="text"
                      name="city"
                      value={driverData.city}
                      onChange={handleChange}
                      className="driver-form__input"
                      required
                    />
                  </div>
                </div>
              </section>

              <section className="driver-form__section">
                <h2 className="driver-form__section-header">
                  <FiCamera /> Driver Photo
                </h2>
                <div 
                  className="driver-form__upload"
                  onClick={() => !uploading && fileInputRef.current.click()}
                >
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleImageUpload}
                    accept="image/*"
                    className="driver-form__upload-input"
                    disabled={uploading}
                  />
                  <div className="driver-form__upload-content">
                    {uploading ? (
                      <p>Uploading image...</p>
                    ) : (
                      <>
                        <FiUpload className="driver-form__upload-icon" size={24} />
                        <p className="driver-form__upload-text">Click to upload driver photo</p>
                        <p className="driver-form__upload-hint">JPG or PNG, max 2MB</p>
                      </>
                    )}
                  </div>
                </div>
                {driverData.imageUrl && (
                  <img 
                    src={driverData.imageUrl} 
                    alt="Driver preview" 
                    className="driver-form__preview"
                  />
                )}
              </section>

              <button 
                type="submit" 
                className="driver-form__submit"
                disabled={uploading}
              >
                {uploading ? "Processing..." : <><FiSave className="mr-2" /> Save Driver</>}
              </button>
            </form>
          </div>
        )}

        {activeTab === "manageDrivers" && (
          <div className="manage-drivers-container">
            <h1>Manage Drivers</h1>
            <p>View and manage all drivers in the system</p>
            
            <table className="drivers-table">
              <thead>
                <tr>
                  <th>Driver ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Contact No</th>
                  <th>City</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {drivers.map(driver => (
                  <tr key={driver.id}>
                    <td>{driver.driverId}</td>
                    <td>{driver.name}</td>
                    <td>{driver.email}</td>
                    <td>{driver.phone}</td>
                    <td>{driver.city}</td>
                    <td>
                      <span className={`status-badge status-${driver.status || 'active'}`}>
                        {(driver.status || 'active') === 'active' ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td>
<div className="action-buttons">
  <button className="btn btn-profile" onClick={() => handleViewProfile(driver)}>
    <FontAwesomeIcon icon={faUser} />
  </button>
  <button className="btn btn-edit" onClick={() => handleEdit(driver)}>
    <FontAwesomeIcon icon={faPen} />
  </button>
  <button 
    className={`btn btn-toggle ${(driver.status || 'active') === 'inactive' ? 'inactive' : ''}`}
    onClick={() => handleToggleStatus(driver.id, driver.status || 'active')}
  >
    {(driver.status || 'active') === 'active' ? 'Deactivate' : 'Activate'}
  </button>
  <button className="btn btn-delete" onClick={() => handleDelete(driver)}>
    <FontAwesomeIcon icon={faTrash} />
  </button>
</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
{/* Profile Modal */}
{modalType === 'profile' && selectedDriver && (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  }}>
    <div style={{
      background: 'white',
      padding: '20px',
      borderRadius: '8px',
      width: '80%',
      maxWidth: '700px',
      maxHeight: '80vh',
      overflow: 'auto'
    }}>
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
        <h2 style={{margin: 0}}>Driver Profile</h2>
        <button onClick={closeModal} style={{background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer'}}>
          ×
        </button>
      </div>
      
      <div style={{display: 'flex', gap: '20px', flexWrap: 'wrap'}}>
        <div>
          <img 
            src={selectedDriver.imageUrl || 'https://via.placeholder.com/150'} 
            alt={selectedDriver.name} 
            style={{width: '150px', height: '150px', borderRadius: '8px', objectFit: 'cover'}}
          />
        </div>
        
        <div style={{flex: 1}}>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px'}}>
            <div><strong>Driver ID:</strong> {selectedDriver.driverId}</div>
            <div><strong>Name:</strong> {selectedDriver.name}</div>
            <div><strong>Email:</strong> {selectedDriver.email}</div>
            <div><strong>Phone:</strong> {selectedDriver.phone}</div>
            <div><strong>WhatsApp:</strong> {selectedDriver.whatsapp}</div>
            <div><strong>NIC:</strong> {selectedDriver.nic}</div>
            <div><strong>Address:</strong> {selectedDriver.address}</div>
            <div><strong>City:</strong> {selectedDriver.city}</div>
            <div><strong>District:</strong> {selectedDriver.district}</div>
            <div><strong>Province:</strong> {selectedDriver.province}</div>
            <div><strong>Vehicle Name:</strong> {selectedDriver.vehicleName}</div>
            <div><strong>Vehicle Type:</strong> {selectedDriver.vehicleType}</div>
            <div><strong>Number Plate:</strong> {selectedDriver.numberPlate}</div>
            <div><strong>Rate per Km:</strong> LKR {selectedDriver.ratePerKm}</div>
            <div><strong>Status:</strong> 
              <span style={{
                padding: '4px 8px', 
                borderRadius: '4px', 
                backgroundColor: (selectedDriver.status || 'active') === 'active' ? '#d4edda' : '#f8d7da',
                color: (selectedDriver.status || 'active') === 'active' ? '#155724' : '#721c24',
                marginLeft: '8px',
                fontSize: '12px'
              }}>
                {(selectedDriver.status || 'active') === 'active' ? 'Active' : 'Inactive'}
              </span>
            </div>
            <div><strong>Joined Date:</strong> {formatDate(selectedDriver.createdAt)}</div>
          </div>
        </div>
      </div>
      
      <div style={{marginTop: '20px', textAlign: 'right'}}>
        <button 
          onClick={closeModal}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

{/* Edit Modal */}
{/* {modalType === 'edit' && selectedDriver && (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  }}>
    <div style={{
      background: 'white',
      padding: '20px',
      borderRadius: '8px',
      width: '80%',
      maxWidth: '600px',
      maxHeight: '80vh',
      overflow: 'auto'
    }}>
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
        <h2 style={{margin: 0}}>Edit Driver Details</h2>
        <button onClick={closeModal} style={{background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer'}}>
          ×
        </button>
      </div>
      
      <form onSubmit={(e) => {
        e.preventDefault();
        handleSaveEdit(selectedDriver);
      }}>
        <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px'}}>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Driver ID:</label>
            <input 
              value={selectedDriver.driverId || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, driverId: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
              required
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Full Name:</label>
            <input 
              value={selectedDriver.name || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, name: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
              required
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Email:</label>
            <input 
              type="email"
              value={selectedDriver.email || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, email: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
              required
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Phone:</label>
            <input 
              value={selectedDriver.phone || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, phone: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
              required
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>WhatsApp:</label>
            <input 
              value={selectedDriver.whatsapp || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, whatsapp: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>NIC:</label>
            <input 
              value={selectedDriver.nic || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, nic: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
              required
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Address:</label>
            <input 
              value={selectedDriver.address || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, address: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
              required
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>City:</label>
            <input 
              value={selectedDriver.city || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, city: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
              required
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>District:</label>
            <input 
              value={selectedDriver.district || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, district: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid '}}
            />
          </div>
        </div>
      </form>
    </div>
  </div>
)} */}

{modalType === 'edit' && selectedDriver && (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  }}>
    <div style={{
      background: 'white',
      padding: '20px',
      borderRadius: '8px',
      width: '80%',
      maxWidth: '700px',
      maxHeight: '80vh',
      overflow: 'auto'
    }}>
      <div style={{
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '20px'
      }}>
        <h2 style={{margin: 0}}>Edit Driver Details</h2>
        <button 
          onClick={closeModal} 
          style={{
            background: 'none', 
            border: 'none', 
            fontSize: '20px', 
            cursor: 'pointer'
          }}
        >
          ×
        </button>
      </div>
      
      <form onSubmit={(e) => {
        e.preventDefault();
        handleSaveEdit(selectedDriver);
      }}>
        <div style={{
          display: 'grid', 
          gridTemplateColumns: '1fr 1fr', 
          gap: '15px'
        }}>
          {/* Driver Info */}
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Driver ID:</label>
            <input 
              value={selectedDriver.driverId || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, driverId: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
              required
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Full Name:</label>
            <input 
              value={selectedDriver.name || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, name: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
              required
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Email:</label>
            <input 
              type="email"
              value={selectedDriver.email || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, email: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
              required
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Phone:</label>
            <input 
              value={selectedDriver.phone || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, phone: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
              required
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>WhatsApp:</label>
            <input 
              value={selectedDriver.whatsapp || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, whatsapp: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>NIC:</label>
            <input 
              value={selectedDriver.nic || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, nic: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
              required
            />
          </div>

          {/* Address Info */}
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Address:</label>
            <input 
              value={selectedDriver.address || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, address: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
              required
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>City:</label>
            <input 
              value={selectedDriver.city || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, city: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
              required
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>District:</label>
            <input 
              value={selectedDriver.district || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, district: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Province:</label>
            <input 
              value={selectedDriver.province || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, province: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
            />
          </div>

          {/* Vehicle Info */}
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Vehicle Name:</label>
            <input 
              value={selectedDriver.vehicleName || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, vehicleName: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Vehicle Type:</label>
            <input 
              value={selectedDriver.vehicleType || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, vehicleType: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Number Plate:</label>
            <input 
              value={selectedDriver.numberPlate || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, numberPlate: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
            />
          </div>
          <div>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Rate per Km (LKR):</label>
            <input 
              type="number"
              value={selectedDriver.ratePerKm || ''}
              onChange={(e) => setSelectedDriver({...selectedDriver, ratePerKm: e.target.value})}
              style={{width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{
          display: 'flex', 
          justifyContent: 'flex-end', 
          marginTop: '20px', 
          gap: '10px'
        }}>
          <button 
            type="button" 
            onClick={closeModal} 
            style={{
              padding: '8px 16px', 
              border: '1px solid #ddd', 
              borderRadius: '4px', 
              background: '#f5f5f5', 
              cursor: 'pointer'
            }}
          >
            Close
          </button>
          <button 
            type="submit" 
            style={{
              padding: '8px 16px', 
              border: 'none', 
              borderRadius: '4px', 
              background: '#007bff', 
              color: 'white', 
              cursor: 'pointer'
            }}
          >
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
)}







     
            
{/* Delete Confirmation Modal */}
{modalType === 'delete' && selectedDriver && (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  }}>
    <div style={{
      background: 'white',
      padding: '20px',
      borderRadius: '8px',
      width: '80%',
      maxWidth: '500px',
      textAlign: 'center'
    }}>
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
        <h2 style={{margin: 0}}>Confirm Deletion</h2>
        <button onClick={closeModal} style={{background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer'}}>
          ×
        </button>
      </div>
      
      <div style={{marginBottom: '20px'}}>
        <div style={{fontSize: '48px', color: '#dc3545', marginBottom: '15px'}}>⚠️</div>
        <p style={{margin: '10px 0'}}>
          Are you sure you want to delete the account of <strong>{selectedDriver.name}</strong>?
        </p>
        <p style={{margin: '10px 0', color: '#666'}}>
          This action cannot be undone and all data associated with this driver will be permanently removed from the system.
        </p>
      </div>
      
      <div style={{display: 'flex', gap: '10px', justifyContent: 'center'}}>
        <button 
          onClick={closeModal}
          style={{
            padding: '10px 20px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Cancel
        </button>
        <button 
          onClick={() => handleConfirmDelete(selectedDriver.id)}
          style={{
            padding: '10px 20px',
            backgroundColor: '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Delete Account
        </button>
      </div>
    </div>
  </div>
)}



          </div>
        )}

        {activeTab === "viewAllBookings" && (
          <div className="tab-content active">
            <h1>View All Bookings</h1>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Pickup</th>
                  <th>Dropoff</th>
                  <th>Pickup Date</th>
                  <th>Pickup Time</th>
                  <th>Vehicle Type</th>
                  <th>Transfer Type</th>
                  <th>Adults</th>
                  <th>Children</th>
                  <th>Comment</th>
                </tr>
              </thead>
              <tbody>
                {bookings.map((b) => (
                  <tr key={b.id}>
                    <td>{b.firstName}</td>
                    <td>{b.lastName}</td>
                    <td>{b.email}</td>
                    <td>{b.phone}</td>
                    <td>{b.pickup}</td>
                    <td>{b.dropoff}</td>
                    <td>{b.pickupDate}</td>
                    <td>{b.pickupTime}</td>
                    <td>{b.vehicleType}</td>
                    <td>{b.transferType}</td>
                    <td>{b.adultsCount}</td>
                    <td>{b.childrenCount}</td>
                    <td>{b.comment}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {activeTab === "viewAllFeedbacks" && (
          <div className="feedback-section">
            <h1>All Feedbacks</h1>
            <div className="feedback-list">
              {feedbacks.map((feedback, index) => (
                <div key={index} className="feedback-card">
                  <div className="feedback-text">{feedback.feedback}</div>
                  <div className="feedback-timestamp">
                    {feedback.timestamp?.toDate().toLocaleString()}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
{/******************************************************************************************************************************/}


{activeTab === "tourHistory" && (
  <div className="tour-management-container">
    <h1 className="heading-tour-history">Tour Management</h1>
    
    {/* Create Tour Form */}
    <div className="tour-form-section">
      <h2>Create New Tour</h2>
      <form onSubmit={handleTourSubmit} className="tour-form">
        <div className="form-row">
          <div className="form-group">
            <label>Select Driver</label>
            <select 
              value={selectedDriverId} 
              onChange={(e) => setSelectedDriverId(e.target.value)}
              required
            >
              <option value="">Select a driver</option>
              {drivers.map(driver => (
                <option key={driver.id} value={driver.id}>
                  {driver.name} ({driver.driverId})
                </option>
              ))}
            </select>
          </div>
          
          {selectedDriverDetails && (
            <>
              <div className="form-group">
                <label>Driver ID</label>
                <input 
                  type="text" 
                  value={selectedDriverDetails.driverId} 
                  readOnly 
                />
              </div>
              <div className="form-group">
                <label>Driver Email</label>
                <input 
                  type="email" 
                  value={selectedDriverDetails.email} 
                  readOnly 
                />
              </div>
            </>
          )}
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label>Pickup Location</label>
            <input 
              type="text" 
              value={tourData.pickupLocation} 
              onChange={(e) => setTourData({...tourData, pickupLocation: e.target.value})}
              required 
            />
          </div>
          
          <div className="form-group">
            <label>Drop Location</label>
            <input 
              type="text" 
              value={tourData.dropLocation} 
              onChange={(e) => setTourData({...tourData, dropLocation: e.target.value})}
              required 
            />
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label>Tour Date</label>
            <input 
              type="date" 
              value={tourData.tourDate} 
              onChange={(e) => setTourData({...tourData, tourDate: e.target.value})}
              required 
            />
          </div>
          
          <div className="form-group">
            <label>Tour Time</label>
            <input 
              type="time" 
              value={tourData.tourTime} 
              onChange={(e) => setTourData({...tourData, tourTime: e.target.value})}
              required 
            />
          </div>
          
          <div className="form-group">
            <label>Tour Charges (LKR)</label>
            <input 
              type="number" 
              value={tourData.tourCharges} 
              onChange={(e) => setTourData({...tourData, tourCharges: e.target.value})}
              required 
            />
          </div>
        </div>
        
        <div className="form-group">
          <label>Additional Notes</label>
          <textarea 
            value={tourData.notes} 
            onChange={(e) => setTourData({...tourData, notes: e.target.value})}
            rows="3"
          />
        </div>
        
        <button type="submit" className="btn-submit-tour">
          Create Tour
        </button>
      </form>
    </div>
    
    {/* Tour History Table */}
    <div className="tour-history-section">
      <h2>Tour History</h2>
      
      <div className="tour-filters">
        <input 
          type="text" 
          placeholder="Search tours..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <select 
          value={filterDriver} 
          onChange={(e) => setFilterDriver(e.target.value)}
          className="filter-select"
        >
          <option value="">All Drivers</option>
          {drivers.map(driver => (
            <option key={driver.id} value={driver.id}>
              {driver.name}
            </option>
          ))}
        </select>
      </div>
      
      {loadingTours ? (
        <div className="loading">Loading tours...</div>
      ) : (
        <table className="tours-table">
          <thead>
            <tr>
              <th>Tour ID</th>
              <th>Driver Name</th>
              <th>Driver ID</th>
              <th>Pickup Location</th>
              <th>Drop Location</th>
              <th>Date & Time</th>
              <th>Charges (LKR)</th>
              {/* <th>Status</th> */}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredTours.map(tour => (
              <tr key={tour.id}>
                <td>{tour.tourId}</td>
                <td>{tour.driverName}</td>
                <td>{tour.driverId}</td>
                <td>{tour.pickupLocation}</td>
                <td>{tour.dropLocation}</td>
                <td>{new Date(tour.tourDate).toLocaleDateString()} at {tour.tourTime}</td>
                <td>{tour.tourCharges}</td>
                {/* <td>
                  <span className={`tour-status tour-status-${tour.status || 'scheduled'}`}>
                    {tour.status || 'Scheduled'}
                  </span>
                </td> */}
                <td>
                  <div className="tour-actions">
  

                    <button 
                      className="btn-delete-tour"
                      onClick={() => handleDeleteTour(tour.id)}
                    >
                      Delete                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  </div>
)}



{/******************************************************************************************************************************/}


        {activeTab === "contactMessage" && (
            <div className="tab-content active">
            <h3>View Contact Messages</h3>
            {messages.length === 0 ? (
              <p>No messages found.</p>
            ) : (
              <table className="contact-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>subject</th>
                    <th>Message</th>
         
                  </tr>
                </thead>
                <tbody>
                  {messages.map((msg) => (
                    <tr>
                      <td>{msg.name}</td>
                      <td>{msg.email}</td>
                      <td>{msg.subject}</td>
                      <td>{msg.message}</td>
         
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

{/******************************************************************************************************************************/}


      </div>
    </div>
  );
}

export default AdminPanel;
